import styled from 'styled-components'
import { palette } from '../../style/globalColor'

export const FollowCompoWrapper = styled.section`
  padding:180px 0 220px 0;
  width: 210px;
  display : block;
  margin:0 auto;
  text-align:center;
`
export const DefaultTxt = styled.p`
  font-size: 14px;
  margin-bottom:20px;
  color: ${palette.darkGray};
`